import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal'
import { AlertService } from '../../../common/alert/shared/alert.service'
import { Comparator } from '../../../core/util/comparator'
import { Bandeira } from '../../../pkw-data/collect/bandeira.model'
import { OperadoraDeMaquina } from '../../../pkw-data/collect/operadora-de-maquina.model'
import { Configuracao } from '../../../pkw-data/core/configuracao/configuracao.model'
import { ConfiguracaoIntegracaoBandeira } from '../../shared/configuracao-integracao-bandeira'
import { ValorIntegracaoConciliadorWCONT } from '../../shared/configuracao-integracao-operadora'
import { ConfiguracaoBandeiraModalEdicaoComponent } from './configuracao-bandeira-modal-edicao/configuracao-bandeira-modal-edicao.component'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoBandeiraModalVisualizacaoComponent } from './configuracao-bandeira-modal-visualizacao/configuracao-bandeira-modal-visualizacao.component'

@Component({
    selector: 'col-configuracao-integracao-bandeira',
    templateUrl: './configuracao-integracao-bandeira.component.html',
    styles: ['.panel-default .panel-heading a { color: var(--tertiaryColor); }']
})
export class ConfiguracaoIntegracaoBandeiraComponent implements OnInit {
    configuracoes: ConfigsBandeirasOperadora[]
    collapseAberto: string
    configuracaoExclusao: ConfiguracaoIntegracaoBandeira

    @ViewChild('confirmarExclusaoModal') confirmarExclusaoModal: ModalDirective

    private todasOperadoras: OperadoraDeMaquina[]
    private todasBandeiras: Bandeira[]
    private configuracao: Configuracao
    private valor: ValorIntegracaoConciliadorWCONT

    constructor(
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService
    ) {}

    ngOnInit() {
        const data = this.route.parent.snapshot
            .data as ConfiguracaoIntegracaoBandeiraRouteData
        this.todasOperadoras = data.todasOperadoras
        this.todasBandeiras = data.todasBandeiras
        this.configuracao = data.configuracao
        this.valor = this.configuracao.getValor<ValorIntegracaoConciliadorWCONT>()
        this.initConfiguracoes()
    }

    nova() {
        const modal = this.modalService.show(ConfiguracaoBandeiraModalEdicaoComponent, {
            initialState: {
                configuracao: new ConfiguracaoIntegracaoBandeira(),
                configuracoesExistentes: this.configuracoes,
                operadoras: this.todasOperadoras.filter(e => e.ativo),
                bandeiras: this.todasBandeiras
            },
            ignoreBackdropClick: true
        })
        const component = modal.content as ConfiguracaoBandeiraModalEdicaoComponent

        component.salvo.subscribe(configBandeira => {
            this.inserirNova(configBandeira)
            modal.hide()
            this.salvar().subscribe(() => {
                this.alertService.success('Nova bandeira configurada.', 'Aviso')
            })
        })
    }

    visualizar(configuracao: ConfiguracaoIntegracaoBandeira) {
        this.modalService.show(ConfiguracaoBandeiraModalVisualizacaoComponent, {
            initialState: {
                configuracao
            },
            ignoreBackdropClick: true
        })
    }

    editar(configuracao: ConfiguracaoIntegracaoBandeira) {
        const obj = new ConfiguracaoIntegracaoBandeira(
            configuracao.operadora,
            configuracao.bandeira,
            configuracao.codigos
        )

        const modal = this.modalService.show(ConfiguracaoBandeiraModalEdicaoComponent, {
            initialState: {
                configuracao: obj,
                configuracoesExistentes: this.configuracoes,
                operadoras: this.todasOperadoras.filter(e => e.ativo),
                bandeiras: this.todasBandeiras
            },
            ignoreBackdropClick: true
        })
        const component = modal.content as ConfiguracaoBandeiraModalEdicaoComponent

        component.salvo.subscribe(configBandeira => {
            this.atualizarConfig(configBandeira)
            modal.hide()
            this.salvar().subscribe(() => {
                this.alertService.info('Informações atualizadas.', 'Aviso')
            })
        })
    }

    validarExclusao(configuracao: ConfiguracaoIntegracaoBandeira) {
        this.configuracaoExclusao = configuracao
        this.confirmarExclusaoModal.show()
    }

    confirmarExclusao() {
        this.confirmarExclusaoModal.hide()
        this.excluir(this.configuracaoExclusao)
        this.salvar().subscribe(() => {
            this.alertService.info('Bandeira excluida.', 'Aviso')
        })
    }

    recusarExclusao() {
        this.configuracaoExclusao = null
        this.confirmarExclusaoModal.hide()
    }

    toggleCollapse(configBandeirasOperadora: ConfigsBandeirasOperadora) {
        this.collapseAberto = this.isAberto(configBandeirasOperadora)
            ? ''
            : configBandeirasOperadora.operadora.codename
    }

    isAberto(configBandeirasOperadora: ConfigsBandeirasOperadora) {
        return this.collapseAberto === configBandeirasOperadora.operadora.codename
    }

    private inserirNova(configBandeira: ConfiguracaoIntegracaoBandeira): any {
        let configBandeirasOperadora = this.configuracoes.find(
            config => config.operadora === configBandeira.operadora
        )

        if (!configBandeirasOperadora) {
            configBandeirasOperadora = {
                operadora: configBandeira.operadora,
                configuracoesBandeiras: []
            }
            this.configuracoes.push(configBandeirasOperadora)
        }

        configBandeirasOperadora.configuracoesBandeiras.push(configBandeira)

        this.ordenarConfiguracoes()
    }

    private excluir(configBandeira: ConfiguracaoIntegracaoBandeira) {
        let configBandeiraIndex: number
        const configOperadoraIndex = this.configuracoes.findIndex(config => {
            configBandeiraIndex = config.configuracoesBandeiras.indexOf(configBandeira)
            return configBandeiraIndex > -1
        })
        const configBandeirasOperadora = this.configuracoes[configOperadoraIndex]

        configBandeirasOperadora.configuracoesBandeiras.splice(configBandeiraIndex, 1)

        if (configBandeirasOperadora.configuracoesBandeiras.length === 0) {
            this.configuracoes.splice(configOperadoraIndex, 1)
        }
    }

    private atualizarConfig(configBandeira: ConfiguracaoIntegracaoBandeira) {
        const configBandeirasOperadora = this.configuracoes.find(
            config => config.operadora === configBandeira.operadora
        )
        const configBandeiraAntiga = configBandeirasOperadora.configuracoesBandeiras.find(
            config =>
                config.operadora === configBandeira.operadora &&
                config.bandeira === configBandeira.bandeira
        )

        Object.assign(configBandeiraAntiga.codigos, configBandeira.codigos)
    }

    private ordenarConfiguracoes() {
        this.configuracoes.sort((configA, configB) =>
            Comparator.string(configA.operadora.nome, configB.operadora.nome)
        )

        this.configuracoes.forEach(config => {
            config.configuracoesBandeiras.sort((configA, configB) =>
                Comparator.string(configA.bandeira.descricao, configB.bandeira.descricao)
            )
        })
    }

    private salvar() {
        this.atualizarValorConfiguracao()
        return this.configuracao.save()
    }

    private initConfiguracoes() {
        const configs = this.valor.CodigosContabeis.filter(
            codigos => codigos.Bandeira && codigos.NomeDaOperadora
        ).map(codigos => {
            const operadora = this.todasOperadoras.find(
                op => op.nome === codigos.NomeDaOperadora
            )
            const bandeira = this.todasBandeiras.find(
                band => band.descricao === codigos.Bandeira
            )

            return new ConfiguracaoIntegracaoBandeira(operadora, bandeira, codigos)
        })

        const operadoras = configs
            .map(config => config.operadora)
            .filter((operadora, i, self) => self.indexOf(operadora) === i)
            .filter((operadora) => operadora.ativo)

        this.configuracoes = operadoras.map(operadora => {
            return {
                operadora: operadora,
                configuracoesBandeiras: configs.filter(
                    config => config.operadora === operadora
                )
            }
        })

        if (this.configuracoes.length) {
            this.collapseAberto = this.configuracoes[0].operadora.codename
        }
    }

    private atualizarValorConfiguracao() {
        const codigosDeConfigsPorOperadora = this.valor.CodigosContabeis.filter(
            codigos => codigos.NomeDaOperadora && !codigos.Bandeira
        )
        const codigosDeConfigsPorBandeira = this.configuracoes
            .map(config => config.configuracoesBandeiras)
            .reduce((configs, configsBandeirasOperadora) => {
                return configs.concat(configsBandeirasOperadora)
            }, [])
            .map(configsBandeirasOperadora => configsBandeirasOperadora.codigos)

        this.valor.CodigosContabeis = codigosDeConfigsPorOperadora.concat(
            codigosDeConfigsPorBandeira
        )
        this.configuracao.setValor(this.valor)
    }
}

export interface ConfiguracaoIntegracaoBandeiraRouteData {
    todasOperadoras: OperadoraDeMaquina[]
    todasBandeiras: Bandeira[]
    configuracao: Configuracao
}

export interface ConfigsBandeirasOperadora {
    operadora: OperadoraDeMaquina
    configuracoesBandeiras: ConfiguracaoIntegracaoBandeira[]
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-bandeira/configuracao-integracao-bandeira.component.ts